// Module
var code = "<media-preview previewer-id=\"{{$ctrl.mediaPreviewId}}\" media=\"$ctrl.media\" options=\"$ctrl.mediaPreviewOptions\"></media-preview>";
// Exports
module.exports = code;